// ─── GLOBAL STYLES ──────────────────────────────────────────────────────────

export const globalStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Cinzel+Decorative:wght@400;700&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body, #root { background: #0f0c0a; color: #e8dcc8; font-family: 'Palatino Linotype', 'Book Antiqua', Palatino, serif; min-height: 100vh; }
  input, select, textarea { background: transparent; border: none; outline: none; color: #e8dcc8; font-family: inherit; }
  input::-webkit-scrollbar, textarea::-webkit-scrollbar { display: none; }
`;

// ─── BUTTON STYLES ──────────────────────────────────────────────────────────

export function btnStyle(color, bg) {
  return {
    background: bg,
    border: `1px solid ${color}`,
    color,
    padding: "8px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    fontFamily: "'Cinzel', serif",
    fontSize: "12px",
    letterSpacing: "1px",
    transition: "all 0.2s"
  };
}

// ─── COLOR PALETTE ──────────────────────────────────────────────────────────
// You can add color constants here later if needed

export const colors = {
  primary: "#c9a84c",
  might: "#c0392b",
  speed: "#2980b9",
  intellect: "#8e44ad",
  magic: "#16a085",
  // Add more as needed
};
